import React, { Fragment } from 'react';
import classNames from 'classnames';
import SkipLink from 'components/SkipLink';
import { useWtrSelector } from 'redux/hooks';

import ContentLocation from 'components/ContentLocation';
import SiteHeaderWrapper from 'components/SiteHeaderWrapper';
import { EOS_NEW_HEADER_WITH_WARRANT } from 'constants/monetateExperiments';
import ReturnToAdmin from 'components/ReturnToAdmin';
import SiteFooter from 'components/Footer/SiteFooter';

import { createFetcherChain } from 'route-data/common-fetch';
import { all } from 'route-data/all';
import { navigationFetcher } from 'redux/fetchers/navigation';
import { fetchHomePage } from 'redux/modules/search-and-browse/actions/fetch-homepage';
import Canonical from 'components/Canonical';
import { getExperimentValueById } from 'redux/modules/experiments/selectors';
import onboardingExperienceFragmentFetcher from 'redux/fetchers/onboarding-experience-fragment';

import styles from './HomePage.scss';

const HomePage = () => {
  const displayWarrant = useWtrSelector(
    state =>
      getExperimentValueById(state, EOS_NEW_HEADER_WITH_WARRANT.experiment) ===
      EOS_NEW_HEADER_WITH_WARRANT.variant.withWarrant,
  );

  return (
    <Fragment>
      {/* @ts-expect-error untyped component */}
      <Canonical href="https://www.waitrose.com/" />
      <SkipLink destination="#main">Skip to main content</SkipLink>
      <ReturnToAdmin />
      <SiteHeaderWrapper isHomepage={displayWarrant} />
      <main id="main">
        <div
          data-testid="content-wrapper"
          className={classNames(styles.body, styles.hideShopWindows)}
        >
          <ContentLocation name="body" preloadImages />
        </div>
      </main>
      <SiteFooter />
    </Fragment>
  );
};

export const homepageFetcher = createFetcherChain({
  fetchersInParallel: all(fetchHomePage, navigationFetcher, onboardingExperienceFragmentFetcher),
});

export default HomePage;
